import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import RouteNames from "@/router/RouteNames";
import useModal from "@/composables/useModal";

export default function useUserService() {
  const store = useStore();
  const router = useRouter();

  const { alert } = useModal();

  const userId = computed(() => store.state.userId);
  const name = computed(() => store.state.name);
  const custNo = computed(() => store.state.custNo);
  const telephone = computed(() => store.state.telephone);
  const email = computed(() => store.state.email);
  const gender = computed(() => store.state.gender);
  const grade = computed(() => store.state.grade);
  const recommendUsername = computed(() => store.state.recommendUsername);
  const chnlLargeCd = computed(() => store.state.chnlLargeCd);
  const chnlMiddleCd = computed(() => store.state.chnlMiddleCd);

  const userName = computed(() => store.getters.userName);
  const isMemberVIP = computed(() => store.getters.isMemberVIP);

  async function logout() {
    await router.push({
      name: RouteNames.MainView,
      force: true,
    });

    await store.dispatch("logOut");

    alert("로그아웃되었습니다.");
  }

  return {
    userId,
    name,
    custNo,
    telephone,
    email,
    gender,
    grade,
    recommendUsername,
    chnlLargeCd,
    chnlMiddleCd,
    userGrade: grade,
    userName,
    isMemberVIP,
    logout,
  };
}
